import React from 'react'
import Packages from './Packages'

const Vetpart = () => {
  return (
    <div>
        <div style={{ backgroundImage: 'url(./mmm.jpg)', height: "600px", width: "100%", backgroundRepeat: "no-repeat" }}>

        </div>
        <div className="bg-white py-16 w-[75%] ml-[12%] mt-[-150px] shadow-xl">
      <div className="max-w-6xl mx-auto px-6">
      
        <h2 className="text-3xl font-bold text-gray-800 text-center mb-8">
          Book Trusted Veterinary Consultation For Pets Near You
        </h2>

        
        <div className="text-center mb-6">
          <button className="bg-orange-500 text-white font-bold text-xl py-3 px-8 rounded-lg shadow-lg hover:bg-orange-600 transition-all">
            Book a Vet Consultation
          </button>
        </div>

        
        <div className="text-center mb-6">
          <p className="text-gray-700 text-lg">OR</p>
          <p className='text-2xl'>Download the app</p>
        </div>

       
        <div className="text-center">
          <p className="text-xl font-semibold text-gray-700 mb-4">
            Consult with the Veterinarian faster with our mobile app
          </p>
          <div className="flex justify-center gap-6">
           
            <a href="https://play.google.com/store/apps" target="_blank" rel="noopener noreferrer">
              <img
                src="//dm6g3jbka53hp.cloudfront.net/static-images/partner-portal_download-androidapp-icon.png"
                alt="Download on Google Play"
                className="w-40 h-auto"
              />
            </a>

            
            <a href="https://apps.apple.com" target="_blank" rel="noopener noreferrer">
              <img
                src="//dm6g3jbka53hp.cloudfront.net/static-images/partner-portal_download-iOSapp-icon.png"
                alt="Download on the App Store"
                className="w-40 h-auto"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div className="bg-gray-50 py-16">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-3xl font-bold text-gray-800 text-center mb-8">
          How Online Veterinarian Service Works
        </h2>

        <div className="flex flex-col lg:flex-row items-center gap-8">
          <div className="flex-1">
            <div className="mb-8 lg:mb-0">
              <h3 className="text-2xl font-semibold text-gray-800 mb-4">Step 1: Ask a Question</h3>
              <p className="text-gray-600">
                Ask anything related to health, nutrition, or behavior of your pet.
              </p>
            </div>

            <div className="mb-8 lg:mb-0">
              <h3 className="text-2xl font-semibold text-gray-800 mb-4">Step 2: Tell Us More About Your Pet</h3>
              <p className="text-gray-600">
                You can even upload photos and medical documents if you desire.
              </p>
            </div>

            <div>
              <h3 className="text-2xl font-semibold text-gray-800 mb-4">Step 3: Receive a Response</h3>
              <p className="text-gray-600">
                A real Veterinarian answers your questions and/or begins LIVE chat with you.
              </p>
            </div>
          </div>

          
          <div className="flex-1">
            <img
              src="//dm6g3jbka53hp.cloudfront.net/static-images/vet-examing-puppy-28032020.jpg" 
              alt="Online Vet Service"
              className="w-full rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </div>
    <div className="bg-gray-50 py-16">
  <div className="max-w-7xl mx-auto px-6">

    <div className="flex flex-col lg:flex-row items-center gap-12">
      
      <div className="flex-1 text-center lg:text-left space-y-6">
        <h3 className="text-3xl font-semibold text-gray-800">
          Curated by Vets for Your Pet's Unique Needs
        </h3>
        <p className="text-lg text-gray-600">
          24/7 advice from India's qualified vets wherever you are. Quick access, right when you need it. No appointment necessary.
        </p>
        <p className="text-lg text-gray-600">
          Available from any smartphone or desktop device. Avoid the stress of travel and save time with our easy online consultations.
        </p>
      </div>

      <div className="flex-1 lg:max-w-lg">
        <img
          src="https://dm6g3jbka53hp.cloudfront.net/static-images/dog-on-bed-30032020.png"
          alt="On-Demand Vet Consultation"
          className="w-full h-auto rounded-lg shadow-xl"
        />
      </div>
    </div>

  </div>
</div>

     <div className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl font-bold text-gray-800 text-center mb-8">
          On-Demand Consultations
        </h2>

        <div className="flex flex-col lg:flex-row items-center justify-between gap-12 md:ml-56">
          <div className="flex-1 text-center lg:text-left space-y-6">
            <p className="text-3xl font-bold text-orange-600">
              Starts At ₹199.00
            </p>
            <p className="text-lg text-gray-600">
              Per Appointment
            </p>
            <p className="text-sm text-gray-500">
              <em>CANCEL ANYTIME</em>
            </p>

            <div className="mt-8">
              <button className="bg-orange-500 text-white py-3 px-8 rounded-lg text-lg font-semibold hover:bg-orange-600 transition duration-300">
                Book a Vet Consultation
              </button>
            </div>
          </div>

          <div className="flex-1">
            <div className="space-y-4">
              <p className="text-xl font-semibold text-gray-800">Consultations Available For:</p>
              <ul className="list-disc pl-6 space-y-2 text-lg text-gray-600">
                <li>Digestive Problems</li>
                <li>Wellness and Prevention</li>
                <li>Anxiety Management</li>
                <li>Skin Health</li>
                <li>Mobility Improvement</li>
                <li>Dental Health</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div className="bg-gray-50 py-16">
  <div className="max-w-7xl mx-auto px-6">

    <div className="flex flex-col lg:flex-row items-center gap-12">

      <div className="flex-1 lg:max-w-md">
        <img
          src="./dog.webp"  
          alt="Dog Consultation"
          className="w-full h-auto rounded-lg shadow-xl"
        />
      </div>

     
      <div className="flex-1 text-center lg:text-left space-y-6">
        <h3 className="text-3xl font-semibold text-gray-800">
          Dog Consultation
        </h3>
        <p className="text-lg text-gray-600">
          Nutrition Consultation for your pet's healthy and balanced diet. Get expert advice on dog nutrition and feeding.
        </p>
        <p className="text-lg text-gray-600">
          Dog Parenting Management tips to ensure your pet is well-behaved, happy, and healthy.
        </p>
        <p className="text-lg text-gray-600">
          Behavioral Training Tips for issues like aggression, biting, and jumping. Get professional guidance on improving your dog's behavior.
        </p>

        <button className="bg-orange-500 text-white py-2 px-6 rounded-lg mt-4 font-semibold">
          Book Dog Consultation
        </button>
      </div>

    </div>
  </div>
</div>
<div className="bg-gray-50 py-16 ">
  <div className="max-w-7xl mx-auto px-6">
    <div className="flex flex-col lg:flex-row items-center gap-12">
      <div className="flex-1 space-y-6">
        <h3 className="text-2xl font-semibold text-gray-800">
          Cat Consultation  
        </h3>
        <ul className="text-gray-600 space-y-2">
          <li>Nutrition Consultation</li>
          <li>Cat Parenting Management</li>
          <li>Understanding Cat Signs/Behaviour (Biting, Itching, Too Much Sleeping)</li>
        </ul>
        <button className="bg-orange-500 text-white py-2 px-6 rounded-lg">
          Book Cat Consultation
        </button>
      </div>

    
      <div className="flex-1 lg:max-w-lg mt-8 lg:mt-0">
        <img
          src="./cat.jpeg" 
          alt="Cat Consultation"
          className="w-full h-auto rounded-lg shadow-lg"
        />
      </div>
    </div>
  </div>
</div>
<Packages/>
    </div>
  )
}

export default Vetpart
